// removed by extract-text-webpack-plugin
module.exports = {"ViewUser":"ViewUser__ViewUser__3e2Dw","ViewUserInner":"ViewUser__ViewUserInner__26VS3","Btn":"ViewUser__Btn__22lYP","ViewUserInner2":"ViewUser__ViewUserInner2__1BHr8","Children":"ViewUser__Children__2OGWS"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UserController/ViewUser/ViewUser.css
// module id = 105
// module chunks = 0